import React from 'react';
import type { User, BusinessUser } from '../../../../types/usersDemo';
import { HeadingMedium, HeadingSmall, LabelSmall, LabelMedium } from 'baseui/typography';
import { Button, KIND } from 'baseui/button';
import { Block } from 'baseui/block';
import { UserAvatar } from '../../../../components/UserAvatar';
import { getStatusColor } from '../../utils/helpers';

interface DrawerHeaderProps {
  contact: User | BusinessUser;
  onClose: () => void;
  autoFocusClose?: boolean;
}

import { useEffect, useRef } from 'react';

export const Header: React.FC<DrawerHeaderProps> = ({ contact, onClose, autoFocusClose }) => {
  const closeRef = useRef<HTMLButtonElement | null>(null);
  useEffect(() => {
    if (autoFocusClose && closeRef.current) {
      closeRef.current.focus();
    }
  }, [autoFocusClose]);
  return (
    <div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '24px',
        borderBottom: '1px solid #E2E8F0',
        paddingBottom: '16px'
      }}>
        <HeadingMedium style={{ margin: 0 }}>Contact Detail View</HeadingMedium>
        <Button 
          kind={KIND.tertiary} 
          size="compact"
          onClick={onClose}
          aria-label="Close contact detail view"
          ref={closeRef as any}
          style={{ fontSize: '16px', padding: '8px' }}
        >
          ✕
        </Button>
      </div>

      <Block 
        display="flex" 
        alignItems="center" 
        marginBottom="scale600"
        paddingLeft="scale600"
        paddingRight="scale600"
      >
        <Block marginRight="scale600">
          <UserAvatar 
            name={contact.name} 
            lastName={contact.lastName}
            size={72}
            showInitials={true}
            style={{
              backgroundColor: 'var(--tenant-primary, #000000)',
              border: '2px solid #e0e0e0',
              color: '#ffffff'
            }}
          />
        </Block>
        <Block flex="1">
          <HeadingSmall margin="0 0 scale300 0" color="contentPrimary" $style={{ fontSize: '18px' }}>
            {contact.name} {contact.lastName}
          </HeadingSmall>
          <LabelSmall margin="0 0 scale100 0" color="contentSecondary" $style={{ fontSize: '12px' }}>
            {contact.role === 'Property Manager' ? 'Admin' : contact.role}
          </LabelSmall>
          <Block display="flex" alignItems="center" gridGap="8px">
            {contact.estate && (
              <span
                style={{
                  fontSize: '12px',
                  color: '#666',
                  whiteSpace: 'nowrap'
                }}
                title="Primary property"
              >
                {contact.estate}
              </span>
            )}
            <div 
              style={{ 
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: getStatusColor(contact.status) === 'positive' ? '#E8F5E8' : 
                               getStatusColor(contact.status) === 'warning' ? '#FFF4E6' : 
                               getStatusColor(contact.status) === 'negative' ? '#FDE8E8' : '#F0F0F0',
                color: getStatusColor(contact.status) === 'positive' ? '#2D7738' : 
                       getStatusColor(contact.status) === 'warning' ? '#B7791F' : 
                       getStatusColor(contact.status) === 'negative' ? '#C53030' : '#666',
                fontSize: '12px',
                fontWeight: '500',
                textAlign: 'center',
                minWidth: '60px'
              }}
            >
              {contact.status}
            </div>
          </Block>
        </Block>
      </Block>
    </div>
  );
};

export default Header;


